export default __webpack_public_path__ + "static/media/home-icon.1258b65c.svg";